import { Cart } from './cart';
import { Links } from './links';
import { Followable } from './followable';
import { Image } from './image';


export class User extends Followable {

  id: number;
  avatar: Image;
  language: string;
  email: string;
  bankaccount: string;
  username: string;
  first_name: string;
  last_name: string;
  password: string;
  password_check: string;
  _cart: Cart;
  _links: Links;
  is_tmp: boolean;
  subscription_channel: string[];

  public clone(): User {

    let user = new User();

    user.setData(this);

    return user;
  }
}



// WEBPACK FOOTER //
// ./src/app/Models/user.ts